import { canRead, canWrite } from '../access/rbacAccess'

export const PRICES = {
  LISTS: 'planifica.price_lists',
  SPECIAL: 'planifica.special_prices'
}

export const canViewPriceLists = () => canRead(PRICES.LISTS)

export const canManagePriceLists = () => canWrite(PRICES.LISTS)

export const canViewSpecialPrices = () => canRead(PRICES.SPECIAL)

export const canManageSpecialPrices = () => canWrite(PRICES.SPECIAL)
